import React from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/id';

import styles from './PostDate.module.scss';

interface PostDateProps {
  createdDate: string;
}

const PostDate = (props: PostDateProps) => {
  const { createdDate } = props;
  return (
    <span className={styles['post-date']}>
      {dayjs(createdDate).locale('id').format('D MMMM YYYY')}
    </span>
  );
};

export default PostDate;
